
import { schema } from "./types";
import { IAutomationAppComponent, IAutomationObject } from "../../../types";
import { OverviewPanel, OperatorPanel,ConfigurationPanel } from './';
import { Icon } from './Icon';
import { ParameterPanel } from "./ParameterPanel";
import { schema as schemaRoom } from '../../../SubPlants/SP_Room/types'
import { schema as schemaLight } from '../../../Devices/Light/types'
import { schema as schemaLightVar } from '../../../Devices/LightVar/types'

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: Icon,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    ParameterPanel: ParameterPanel,
    createConfig:     {
        group: "Spaces",
        name: "1st Floor",
        description: "Floor",
        panel: OverviewPanel,
        defaultState: { initialized: true }
    },
    addAppFilter: (app: IAutomationObject) => app.schema === schemaRoom || app.schema === schemaLight || app.schema === schemaLightVar 
}